import React from 'react';
import TableBaseLoaderTemplate from './tableBase';

const OrdersTableLoaderTemplate: React.FC = () => (
  <TableBaseLoaderTemplate columnsNumber={8} rowsNumber={9} />
);

export default OrdersTableLoaderTemplate;
